import { render } from "./GridSop.vue?vue&type=template&id=60b4f69d"
import script from "./GridSop.vue?vue&type=script&lang=js"
export * from "./GridSop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__